import React, { useState } from 'react'

import { Box, Input, InputGroup, InputRightElement } from '@chakra-ui/react'

import { InterviewType } from '@pkg/types/interview'

import { SearchIcon } from '@/views/assets/SearchIcon'
import { EVENT_FILTER_KEY } from '@/views/screens/Home/FilterHeader/const'

export interface EventFilterProps {
  eventFilter: string
  setEventFilter: React.Dispatch<React.SetStateAction<string>>
  selectedTab: InterviewType
}

export function EventFilter({
  eventFilter,
  setEventFilter,
  selectedTab,
}: EventFilterProps) {
  const [isEventFilterFocused, setIsEventFilterFocused] = useState(false)

  function handleFilterChange(value: string): void {
    setEventFilter(value)
    const filterKey =
      EVENT_FILTER_KEY + (selectedTab === 'INTAKE' ? '-intake' : '')
    localStorage.setItem(filterKey, value)
  }

  return (
    <InputGroup
      cursor="text"
      transition="max-width 0.2s ease"
      maxW={isEventFilterFocused || eventFilter ? '180px' : '120px'}
    >
      <Input
        fontWeight="bold"
        ml={-4}
        pr={9}
        variant="brand-solid-white"
        bg={isEventFilterFocused || eventFilter ? 'white' : 'transparent'}
        placeholder="Event"
        _placeholder={{
          color: isEventFilterFocused ? 'blackAlpha.500' : 'black',
        }}
        border={0}
        onChange={(event) => handleFilterChange(event.target.value)}
        onFocus={() => setIsEventFilterFocused(true)}
        onBlur={() => setIsEventFilterFocused(false)}
        _hover={{ bg: 'white' }}
        id="eventFilterInput"
        value={eventFilter}
      />
      <Box as="label" htmlFor="eventFilterInput" cursor="text">
        <InputRightElement
          display="flex"
          alignItems="center"
          justifyContent="center"
          h="100%"
          mr={4}
        >
          <SearchIcon w="14px" h="14px" />
        </InputRightElement>
      </Box>
    </InputGroup>
  )
}
